export enum AccountType {
  AWS = 'aws',
  LOCAL = 'local',
}
